import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Rutas PÚBLICAS de verificación documental. Sin AuthGuard, sin RoleBasedGuard y sin
// RouteGuard: quien entra aquí es un farmacéutico anónimo que acaba de escanear el QR
// de una receta, no un usuario del sistema. Por eso tampoco cuelgan de un layout del
// dashboard ni aparecen en la navegación.
//
// La ruta debe casar con VerificacionReceta:UrlPublicaBase del backend, que es lo que
// se codifica en el QR impreso. Si se renombra aquí, los papeles ya emitidos apuntan a
// una página que no existe: el QR es inmutable una vez impreso.

const RecetaVerificacionPage = lazy(() =>
  import('src/pages/medicore/public-pages/receta-verificacion')
);

export const publicoRoutes = [
  {
    path: 'publico',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      // Sin token: entrada manual, para el papel cuyo QR no se deja leer.
      { path: 'receta', element: <RecetaVerificacionPage /> },
      { path: 'receta/:token', element: <RecetaVerificacionPage /> },
    ],
  },
];
